/**
 * @ngdoc service
 * @name picklists.factory:Picklist
 *
 * @description
 *
 */
angular
    .module('festzelt-os.modules.bo.option-links')
    .factory('BoOptionLink', [
        'locale',
        'Resource',
        BoOptionLink
    ]);

function BoOptionLink(locale, Resource) {
    return Resource.make('bo/option-links');
}



// WEBPACK FOOTER //
// ./src/app/modules/bo/option-links/factories/option-link-factory.js